module.exports = __webpack_public_path__ + "static/media/option-4.7c546ccc.ogg";